import axios from "axios"
import { useRoute, useRouter } from 'vue-router'
import MaskData from 'maskdata'
import moment from 'moment'
import { useReportStore } from '../stores/ReportStore.js'
import { fix, subtract, divide } from 'mathjs'
import shortNumbers from 'short-numbers';

let setDate=(id,url,params,value)=>{
    if(value != ""){
        axios.post(url,{'sent_on':value,'datesent-id':id}).then(({data})=>{

            if(data.error == false){
                toastr.success(data.message, 'Success!');
            }else{
                toastr.error("Please Select a Letter", 'Error!');
            }
        }).catch()
    }else{
        toastr.error("Please ensure you selected a date.", 'Error!');
    }


}
let letterZipDownload=(lettersSelected,url)=>{
    if (lettersSelected.length > 0) {
        axios.post(url,{'ids': lettersSelected}).then(({data})=>{
            if(data.error == false){
                toastr.success(data.message, 'Success');
            }
        }).catch()
    }else {
        toastr.error("Please Select a Letter", 'Error!');
    }
}

const getRoute = (name, params) => {
    const route = useRoute(), router = useRouter();
    const currentRoute = router.resolve(
        {
            name: name,
            params: params
        }
    );
    return currentRoute.href;
}

const mask = (value, options = {}) => {
    return MaskData.maskCard(value, options);
}

const hideModal = (selector) => {
    if ($(selector).find('.close span').length > 0) {
        $(selector).find('.close span').click();
    }
    else {
        $(selector).hide();
    }
}

const closeModal = (selector) => {
    $(selector).modal('hide');
}

const openModal = (selector) => {
    $(selector).modal('show');
}

const daysDiffFromToday = (date) => {
    if (_.isNull(date)) {
        return date;
    }
    let days = 0;
    if (date instanceof moment && date.isValid()) {
        days = moment().diff(date, 'days');
    }
    date = moment(date);
    if (date.isValid()) {
        days = moment().diff(date, 'days');
    }
    if (days > 30 && date.isValid()) {
        return `<span
            class="badge badge-glow badge-sm badge-success"
        >
            Report Available
        </span>`;
    }
    else {
        return formatDate(date.add('days', 30), 'LL');
    }
    return '';
}

const formatDate = (date, format, isUnix = false) => {
    if (isUnix && moment(date, 'X', true).isValid()) {
        return moment.unix(date).format(format);
    }
    if (!useReportStore().isReported(date)) {
        return date;
    }
    if (date instanceof moment && date.isValid()) {
        return date.format(format);
    }
    date = moment(date);
    if (date.isValid()) {
        return date.format(format);
    }
    return date;
}

const isNotNullorUndefined = (value) =>{
    return !_.isNull(value) && !_.isNil(value) && value !== 'undefined' && value !== 'null';
}
const centToDollar = (amount) => {
    return fix(divide(amount, 100), 2);
}
const getRandomBackgroundClass = () => {
    var backgrounds = [
        'bg-light-primary',
        'bg-light-secondary',
        'bg-light-success',
        'bg-light-danger'
    ];
    return _.sample(backgrounds);
}
const debounce = (callback, delay = 1000) =>{
    var timer;

    return (...args) => {
        if(timer){
            clearTimeout(timer);
        }

        timer = setTimeout(() => {
            callback(...args);
            console.log(timer)
        }, delay);
    };
  }
  const convertSecToTime=(secs)=>{
    // const formatted = moment.utc(secs*1000).format('HH:mm:ss');
    const duration = moment.duration(secs, 'seconds');

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    let formattedDuration = '';

    if (hours > 0) {
        formattedDuration += `${hours} hr${hours > 1 ? 's' : ''}`;
    }

    if (minutes > 0) {
        formattedDuration += ` ${minutes} min${minutes > 1 ? 's' : ''}`;
    }

    if (seconds > 0) {
        formattedDuration += ` ${seconds} sec${seconds > 1 ? 's' : ''}`;
    }
    return formattedDuration;
}
const formatNumber=(number)=>{
    return shortNumbers(number, { space: true });
}
const nowDate=()=>{
    const currentDate = moment().format('MM-DD-YYYY');
    return currentDate;
}
const avarage=(sum,count)=>{
    if(sum == 0 && count == 0){
        return "";
    }
    let avarage_rating = sum/count
    let number = avarage_rating.toFixed(1);
    return number;
}
const abbreviateName=(fullname)=>{
    const names = fullname.split(' ');
    const initials = _.map(names, name => _.toUpper(name[0]));
    return _.join(initials, '');
}
export {
    setDate,
    letterZipDownload,
    getRoute,
    mask,
    hideModal,
    closeModal,
    openModal,
    daysDiffFromToday,
    formatDate,
    isNotNullorUndefined,
    centToDollar,
    getRandomBackgroundClass,
    debounce,
    convertSecToTime,
    formatNumber,
    nowDate,
    avarage,
    abbreviateName
}
